import { createContext, useState } from 'react';
import { IRow, IRows, ITab, TabelaAtributosContextProps, TabelaAtributosProviderProps } from './@types/TabelaAtributos';

export const TabelaAtributosContext = createContext({} as TabelaAtributosContextProps);

export function TabelaAtributosProvider({ children }: TabelaAtributosProviderProps) {
  const [open, setOpen] = useState<boolean>(false);
  const [filter, setFilter] = useState <string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  const [openFilter, setOpenFilter] = useState<boolean>(false);

  const [tabs, setTabs] = useState<ITab[]>([]);
  const [rows, setRows] = useState<IRows>({ values: [], totalElements: 0 });
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [currentTab, setCurrentTab] = useState<number>(0);

  const [selected, setSelected] = useState<IRow[]>([]);
  const [selectAll, setSelectAll] = useState<boolean>(false);

  function getCurrentTab(): ITab {
    return tabs[currentTab];
  }
  
  return (
  <TabelaAtributosContext.Provider
    value={{
      open,
      setOpen,
      filter,
      setFilter,
      loading,
      setLoading,

      openFilter,
      setOpenFilter,

      getCurrentTab,
      tabs,
      setTabs,
      rows,
      setRows,
      currentPage,
      setCurrentPage,
      currentTab,
      setCurrentTab,

      selected,
      setSelected,
      selectAll,
      setSelectAll,
    }}
  >
    {children}
  </TabelaAtributosContext.Provider>
  );
}
